import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/opt/buildhome/repo/node_modules/next-themes/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-inter\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["CookieConsent"] */ "/opt/buildhome/repo/src/components/cookieConsent/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["I18nProvider"] */ "/opt/buildhome/repo/src/components/providers/i18nProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/opt/buildhome/repo/src/components/ui/sonner.tsx");
